import type { FC } from "react";
import type { IconName } from "@fortawesome/fontawesome-common-types";
import { Icon } from "@onshopfront/components";

export const PartnerFitColumn: FC<{
    positive: boolean;
    features: Array<string>;
}> = ({ positive, features }) => {
    const wrapperClasses = [
        "rounded-lg p-4 border",
    ];

    let fitTextColour;
    let titleIcon: IconName;
    let itemIcon: IconName;

    if(positive) {
        wrapperClasses.push("bg-green-200 border-green-300");
        fitTextColour = "text-green-700";
        titleIcon = "check-circle";
        itemIcon = "check";
    } else {
        wrapperClasses.push("bg-slate-100 border-slate-200");
        fitTextColour = "text-slate-700";
        titleIcon = "times-circle";
        itemIcon = "minus";
    }

    return (
        <div className={wrapperClasses.join(" ")}>
            <div className="space-y-4">
                <div className={`${fitTextColour} flex gap-2`}>
                    <Icon icon={[ "fal", titleIcon ]} className="text-xs leading-5!" />
                    <span>
                        {positive ? "Right fit" : "Not the right fit"}
                    </span>
                </div>
                {features.map((feature, index) => (
                    <div className="flex gap-2" key={index}>
                        <Icon icon={[ "fal", itemIcon ]} className={`text-xs leading-5! ${fitTextColour}`} />
                        <span>
                            {feature}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
